export default __webpack_public_path__ + "static/media/budget-flights-display.e77b39f0.png";